<template>
	<div>
		<div class="image-preview" @click="openModal">
			<img
				:src="imgUrl"
				alt="image"
				class="img-fluid"
				style="width: 200px; height: auto; cursor: pointer"
			/>
		</div>
		<div v-if="isModalOpen" class="modal">
			<div class="modal-content">
				<span class="close" @click="closeModal">&times;</span>
				<img :src="imgUrl" alt="image" class="img-fluid" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ImagePreview",
	props: {
		imgUrl: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			isModalOpen: false,
		};
	},
	methods: {
		openModal() {
			this.isModalOpen = true;
		},
		closeModal() {
			this.isModalOpen = false;
		},
	},
};
</script>

<style scoped>
.modal {
	display: flex;
	position: fixed;
	z-index: 1000;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: rgba(0, 0, 0, 0.6);
}

.modal-content {
	margin: auto;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 70%;
	padding: 20px;
}

.close {
	position: absolute;
	right: 15px;
	top: 15px;
	color: #aaaaaa;
	font-size: 28px;
	font-weight: bold;
	cursor: pointer;
}

.close:hover,
.close:focus {
	color: #000;
	text-decoration: none;
	cursor: pointer;
}
</style>
